export default {
  pageSize: {
    id: 'bo_sellers-buyback-opportunities-table-page-size',
    defaultMessage: 'Page size',
  },
  loading: {
    id: 'bo_sellers-buyback-opportunities-table-loading',
    defaultMessage: 'Loading opportunities...',
  },
  numberOfOpportunities: {
    id: 'bo_sellers-buyback-opportunities-table-number-of-opportunities',
    defaultMessage: '{numberOfOpportunities} sourcing opportunities',
  },
  lastUpdatedAt: {
    id: 'bo_sellers-buyback-opportunities-table-last-updated-at',
    defaultMessage: 'All data are updated at {lastUpdatedAt}',
  },
  description: {
    id: 'bo_sellers-buyback-opportunities-table-description',
    defaultMessage:
      "We show you the devices on Back Market that yield the most profit and that you're currently missing out on by not sourcing them from Trade-in. You set filters for the markets, categories, and grades you want, see your margin potential instantly, and choose whether to create listings. ",
  },
  seeMoreMargin: {
    id: 'bo_sellers-buyback-opportunities-table-see-more-margin',
    defaultMessage: 'See more margin',
  },
  seeMoreAverageSellingPrice: {
    id: 'bo_sellers-buyback-opportunities-table-see-more-average-selling-price',
    defaultMessage: 'See more average selling price',
  },
}
